import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { cesGroupsFeatureKey } from '../key';
import type { CesGroupsListQueryFilter, CesGroupsListQuerySorter } from './types';

type CesGroupsListQueryType = GenericListQueryKey<CesGroupsListQueryFilter, CesGroupsListQuerySorter>;

export const getCesGroupsListQueryKey = (params: CesGroupsListQueryType) =>
  generateListQueryKey({
    prefix: cesGroupsFeatureKey,
  })(params);

export const getCesGroupsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getCesGroupsListQueryKey,
});
